<template>
  <div> 
    <my-header h1="Entry Test Print"></my-header> 
    <table>
      <tr>
        <td colspan="3">
          <table class="bg-grey table-collapse-12" border="1">
            <tr>
              <th style="width: 12%"> Session: </th>
              <td width="21.3%">{{test.session}}</td>
              <th style="width: 12%"> Test Name: </th>
              <td width="21.3%">{{test.name}}</td>
              <th style="width: 12%"> Timings: </th>
              <td width="21.3%"> {{test.timings}}</td>
            </tr>
            <tr> 
              <th> Program: </th>
              <td colspan="5"><span v-for="(p, ind) in test.program">{{p.ProgramName}}<span v-if="test.program.length > (ind + 1)">, </span></span></td> 
            </tr> 
          </table>
        </td>
      </tr>

      <tr>
        <td colspan="3">
          <div v-for="p in candidates">
            <div style="background-color: lightgray; margin-bottom: -13px;">
              <h4>
                Hall: {{p.HallName}}
              </h4>
            </div>
            <table class=" bg-grey table-collapse-12"border="1">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th style="width: 15%; text-align: center">Form No</th>
                  <th style="width: 25%; text-align: left">Name</th>
                  <th style="width: 25%; text-align: left">Father Name</th>
                  <th style="width: 15%; text-align: center">Hall Name</th>
                  <th style="width: 10%; text-align: center">Row</th>
                  <th style="width: 10%; text-align: center">Seat</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in p.child">
                  <td style="text-align: center">{{index + 1}}</td>
                  <td style="width: 15%; text-align: center">{{item.FormNo}}</td>
                  <td style="width: 25%;">{{item.Name}}</td>
                  <td style="width: 25%;">{{item.FatherName}}</td>
                  <td style="width: 15%; text-align: center">{{item.HallName}}</td>

                  <td style="width: 10%; text-align: center">{{item.RowName}}</td>
                  <td style="width: 10%; text-align: center">{{item.SeatNo}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </table>

  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        id: 0,
        test: null,
        candidates: []
      }
    },

    created: function () {
      //const urlParams = new URLSearchParams(window.location.search);
      //if (urlParams) {
      //  this.id = Number(urlParams.get('id'));
      //  var uri = window.location.toString();
        //if (uri.indexOf("?") > 0) {
        //  var clean_uri = uri.substring(0, uri.indexOf("?"));
        //  window.history.replaceState({}, document.title, clean_uri);
        //}

        this.loadPrint();
      //}

    },

    methods: {
      loadPrint() {
        startReq();
        var vm = this;
        const urlParams = new URLSearchParams(window.location.search);
        const ID = urlParams.get('id');
        axios.post('/api/AdmissionApi/loadEntryTestPrint?ID=' + ID)
          .then(function (res) {
            vm.test = res.data["test"];
            vm.candidates = res.data["candidates"];
            endReq();
          });
      }
    }
  })

</script>
 



// WEBPACK FOOTER //
// src/components/onlineadmission/entryTestPrint.vue